import { Box, Button, TextField, IconButton, InputAdornment, Typography } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useState, useEffect } from "react";
import { useTheme } from "@emotion/react";
import LoadingSpinner from "../../loadingSpinner";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import { PostDatosProductosTejidos } from "../../services/productosTejidos.services";
import ModalCharge from "../../modal/modalCharge";
import MenuItem from '@mui/material/MenuItem';
import imageCompression from "browser-image-compression";
import {getApiBaseUrl} from '../../utils/getApiBaseUrl'; 
import { PostAmoxarifado, PutAmoxarifado } from "../../services/amoxarifado.services";
import ModalCategoriasAmoxarifado from "../../modal/amoxarifado/modalCategorias";
import ModalSubCategoriasAmoxarifado from "../../modal/amoxarifado/modalSubCategorias";
import { useDropzone } from "react-dropzone";
import CloseIcon from "@mui/icons-material/Close";
import ModalDepositoAmoxarifado from "../../modal/amoxarifado/modalDeposito";
import ModalEstante from "../../modal/estante/modalEstante";
import ModalFilaGetOne from "../../modal/fila/modalFilaOneMul";
import ModalEstanteGetOne from "../../modal/estante/modalEstantegetOne";
import ModalColumnaGetOne from "../../modal/columna/modalColumnagetOne";
import { Switch } from "@mui/material";
import ModalProductosAmoxarifado from "../../modal/amoxarifado/modalProductos";
import EditIcon from '@mui/icons-material/Edit';
import secureStorage from "../../utils/secureStorage";






// const SOCKET_URL = 'http://localhost:5004/'; // URL del servidor Socket.IO
// const socket = io(SOCKET_URL, {
//   withCredentials: true,
//   transports: ["websocket", "polling"],
//   query: {
//     token: secureStorage.getItem("authToken"), // Pasar el token al conectarse
//   },
// });

const EditProducto = () => {
  const [isModalChargeOpen, setIsModalChargeOpen] = useState(false);
  const [isModalProductoOpen, setIsModalProductoOpen] = useState(false);
  const [isModalCategoriaOpen, setIsModalCategoriaOpen] = useState(false);
  const [isModalDepositoOpen, setIsModalDepositoOpen] = useState(false);
  const [isModalEstanteOpen, setIsModalEstanteOpen] = useState(false);
  const [isModalFilaOpen, setIsModalFilaOpen] = useState(false);
  const [isModalColumnaOpen, setIsModalColumnaOpen] = useState(false);
  const [estanteSeleccionado, setEstanteSeleccionado] = useState(null);
  const [depositoSeleccionado, setDepositoSeleccionado] = useState(null);
  const [filaSeleccionado, setFilaSeleccionado] = useState(null);
  const [columnaSeleccionado, setColumnaSeleccionado] = useState(null);
  const [serieEnabled, setSerieEnabled] = useState(true);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);
  const [subcategoriaSeleccionada, setSubcategoriaSeleccionada] = useState(null);
  const [isModalSubcategoriaOpen, setIsModalSubcategoriaOpen] = useState(false);
  const [idCategoriaActual, setIdCategoriaActual] = useState(null);
  const [imageBase64, setImageBase64] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const theme = useTheme();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [tipo, setTipo] = useState("");
  const [descuento, setDescuento] = useState("");
  const [droppedItems, setDroppedItems] = useState([]);
  const [dropError, setDropError] = useState('');

  const resetUbicacion = (setFieldValue) => {
  setEstanteSeleccionado(null);
  setFilaSeleccionado(null);
  setColumnaSeleccionado(null);
  setFieldValue("id_estante", "");
  setFieldValue("fila", "");
  setFieldValue("id_ubicacion", "");
};


  const ubicacionFinal =
  depositoSeleccionado && estanteSeleccionado && filaSeleccionado && columnaSeleccionado
    ? `${depositoSeleccionado.deposito} - ${estanteSeleccionado.descripcion} - ${filaSeleccionado.descripcion} - ${columnaSeleccionado.descripcion}`
    : "";
  

  const handleFormSubmit = async (values, { resetForm }) => {
    setIsLoading(true);

    const USER = secureStorage.getItem('id');
    const uploadedPaths = await uploadDroppedImages(droppedItems);

    const { id_producto,id_ubicacion} = values;

    const valuesToSend = {
        id_producto,
        id_ubicacion,
    };

    try {
      await new Promise((resolve) => setTimeout(resolve, 2000));
      const response = await PutAmoxarifado(id_producto, valuesToSend);
      setRegistrationSuccess(true);
      resetForm();
      setDepositoSeleccionado(null);
      setEstanteSeleccionado(null);
      setFilaSeleccionado(null);
      setColumnaSeleccionado(null);
      setCategoriaSeleccionada(null);
      setSubcategoriaSeleccionada(null);
      setIdCategoriaActual(null);
      setDroppedItems([]);
      setImageBase64("");
    } catch (error) {
      console.error("error sending data", error);
      setRegistrationError(true);
      setIsLoading(false);
      setError(error.message);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }
  };

  const handleDrop = (acceptedFiles) => {
  const newItems = acceptedFiles.map((file) => ({
    name: file.name,
    preview: URL.createObjectURL(file),
    file, // Guardar el archivo original
  }));
  setDroppedItems((prevItems) => [...prevItems, ...newItems]);
  setDropError(''); // Limpiar el error cuando se agregan archivos
};

const handleRemoveItem = (index) => {
  setDroppedItems((prevItems) => prevItems.filter((_, i) => i !== index));
};

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: 'image/*',
    onDrop: handleDrop,
  });

  const handleCloseModal = () => {
    setRegistrationSuccess(false);
  };

  const handleCloseModalError = () => {
    setRegistrationError(false);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        event.key === "F9" ||
        (event.key === "Tab" && document.activeElement.name === "id_level")
      ) {
        // setIsModalLevelOpen(true);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleImageChange = async (e, setFieldValue) => {
    const file = e.target.files[0];
    if (file) {
      try {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };
        const compressedFile = await imageCompression(file, options);
        const formData = new FormData();
        formData.append("image", compressedFile);

        const response = await fetch(`${getApiBaseUrl()}upload`, {
          method: "POST",
          body: formData,
        });

        if (response.ok) {
          const data = await response.json();
          setFieldValue("imagen", data.filePath);
          setImageBase64(data.filePath);
        } else {
          console.error("Error al subir la imagen");
        }
      } catch (error) {
        console.error("Error al comprimir la imagen:", error);
      }
    }
  };

  const uploadDroppedImages = async (items) => {
  const uploadedImagePaths = [];

  for (const item of items) {
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };

    try {
      const compressedFile = await imageCompression(item.file, options);
      const formData = new FormData();
      formData.append("image", compressedFile);

      const response = await fetch(`${getApiBaseUrl()}upload`, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        uploadedImagePaths.push(data.filePath); // ← almacena las rutas
      } else {
        console.error("Error al subir la imagen", item.name);
      }
    } catch (error) {
      console.error("Error al comprimir/subir la imagen:", error);
    }
  }

  return uploadedImagePaths;
};


  return (
    <Box m="20px">
      <Header title="Productos" subtitle="Editar Productos" />
      {isLoading && <LoadingSpinner />}
      {registrationSuccess && (
        <ModalSucces open={registrationSuccess} onClose={() => setRegistrationSuccess(false)} />
      )}
      {registrationError && (
        <ModalError
          open={registrationError}
          onClose={() => setRegistrationError(false)}
          error={error}
        />
      )}

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={{
          producto: "",
          id_ubicacion: "",
          id_producto: "",
        }}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => (
          <>
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              {/* PRODUCTO - ocupa 2 columnas */}
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Producto"
                onClick={() => setIsModalProductoOpen(true)}
                InputProps={{ readOnly: true }}
                onChange={() => {}} // evita advertencias de Formik
                onBlur={handleBlur}
                value={values.producto}
                name="producto"
                error={!!touched.producto && !!errors.producto}
                helperText={touched.producto && errors.producto}
                sx={{ gridColumn: "span 1" }}
              />

              {/* UBICACIÓN - también ocupa 2 columnas */}
              <Box
                display="grid"
                gridTemplateColumns="repeat(4, 1fr)" // divide internamente en 4
                gap="15px"
                sx={{ gridColumn: "span 2" }} // ← MUY IMPORTANTE
              >
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Depósito"
                  value={depositoSeleccionado?.deposito || ""}
                  InputProps={{ readOnly: true }}
                  sx={{ gridColumn: "span 1" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Estante"
                  value={estanteSeleccionado?.descripcion || ""}
                  InputProps={{ readOnly: true }}
                  sx={{ gridColumn: "span 1" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Fila"
                  value={filaSeleccionado?.descripcion || ""}
                  InputProps={{ readOnly: true }}
                  sx={{ gridColumn: "span 1" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Columna"
                  value={columnaSeleccionado?.descripcion || ""}
                  InputProps={{ readOnly: true }}
                  sx={{ gridColumn: "span 1" }}
                />
              </Box>
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Ubicación"
                value={ubicacionFinal}
                name="id_ubicacion"
                InputProps={{ readOnly: true }}
                onClick={() => {
                  setIsModalDepositoOpen(true);
                }}
                sx={{ gridColumn: "span 1" }}
                error={!!touched.id_ubicacion && !!errors.id_ubicacion}
                helperText={touched.id_ubicacion && errors.id_ubicacion}
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit" 
                variant="contained"
                sx={{
                  backgroundColor: "rgb(206, 220, 0)",
                  color: "black",
                  height: "7vh",
                  fontSize: "15px",
                  width: "10vw",
                  borderRadius: "20px",
                  mt: 2,
                  "&:hover": { backgroundColor: "#bac609" },
                }}
              >
                <EditIcon sx={{ mr: 2 }} />
                  Editar
              </Button>
            </Box>
            <ModalCharge isLoading={isLoading} />
          </form>
          <ModalProductosAmoxarifado
            open={isModalProductoOpen}
            onClose={() => setIsModalProductoOpen(false)}
            onSelect={(producto) => {
              setFieldValue("producto", producto.producto); // Suponiendo que tiene propiedad `nombre`
              setFieldValue("id_producto", producto.id); 
              setFieldValue("producto", producto.producto);
              setFieldValue("id_producto", producto.id);
              setFieldValue("id_ubicacion", producto.id_ubicacion);
              setFieldValue("id_estante", producto.id_estante);
              setFieldValue("fila", producto.fila);
              setFieldValue("columna", producto.columna);
              setDepositoSeleccionado({ id: producto.id_deposito, deposito: producto.deposito });
              setEstanteSeleccionado({ id: producto.id_estante, descripcion: producto.estante });
              setFilaSeleccionado({ id: producto.id_fila, descripcion: producto.fila });
              setColumnaSeleccionado({ id: producto.id_columna, descripcion: producto.columna });
              setIsModalProductoOpen(false);             
            }}
        />

          <ModalDepositoAmoxarifado
            open={isModalDepositoOpen}
            onClose={() => setIsModalDepositoOpen(false)}
            onSelect={(deposito) => {
              setFieldValue("id_dep", deposito.id); 
              setDepositoSeleccionado(deposito); 
              resetUbicacion(setFieldValue);    // Guardar el depósito
              setIsModalDepositoOpen(false);         // Cerrar modal de depósito
              setIsModalEstanteOpen(true);           // Abrir modal de estante
            }}
          />
          <ModalEstanteGetOne
            open={isModalEstanteOpen}
            onClose={() => setIsModalEstanteOpen(false)}
            idDeposito={depositoSeleccionado?.id}
            nombreDeposito={depositoSeleccionado?.deposito} 
            onSelect={(estante) => {
              setFieldValue("id_estante", estante.id);
              setEstanteSeleccionado(estante);
              setIsModalEstanteOpen(false);
              setIsModalFilaOpen(true);               // Abrimos modal de fila
            }}
          />
          <ModalFilaGetOne
            open={isModalFilaOpen}
            onClose={() => setIsModalFilaOpen(false)}
            idEstante={estanteSeleccionado?.id}
            nombreEstante={estanteSeleccionado?.descripcion}
            onSelect={(fila) => {
              setFieldValue("fila", fila.fila);
              setFilaSeleccionado(fila);
              setIsModalFilaOpen(false);
              setIsModalColumnaOpen(true);
            }}
          />
          <ModalColumnaGetOne
            open={isModalColumnaOpen}
            onClose={() => setIsModalColumnaOpen(false)}
            idFila={filaSeleccionado?.id}
            nombreFila={filaSeleccionado?.descripcion}
            onSelect={(columna) => {
              setFieldValue("id_ubicacion", columna.id);
              setColumnaSeleccionado(columna);
              setIsModalColumnaOpen(false);
            }}
          />
          <ModalCategoriasAmoxarifado
            open={isModalCategoriaOpen}
            onClose={() => setIsModalCategoriaOpen(false)}
            onSelect={(categoria) => {
              setCategoriaSeleccionada(categoria);
              setFieldValue("id_categoria", categoria.id);
              setIdCategoriaActual(categoria.id);
              setIsModalCategoriaOpen(false);
              setIsModalSubcategoriaOpen(true);
            }}
          />
          <ModalSubCategoriasAmoxarifado
            open={isModalSubcategoriaOpen}
            onClose={() => setIsModalSubcategoriaOpen(false)}
            idCategoria={idCategoriaActual} 
            nombreCategoria={categoriaSeleccionada?.categoria}
            onSelect={(subcategoria) => {
              setSubcategoriaSeleccionada(subcategoria);                     
              setFieldValue("id_subcategoria", subcategoria.id); 
              setIsModalSubcategoriaOpen(false);
            }}
          />

        </>

        )}
        
      </Formik>
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
    producto: yup.string().required("El producto es requerido"),
    id_ubicacion: yup.number().required("La nueva ubicación es requerida"),
});

export default EditProducto;